<qmg-graph-tile
   #graphTile
   [tileConfig]="tileConfig"
   [isFullscreen]="isFullscreen"
   [isEditing]="isEditing"
   [chartDisplayType]="chartType"
   [name]="tileConfig.dashboardTileLayoutConfiguration.name || ''"
   [formService]="formService"
   [showHeader]="showHeader"
   [fallbackTemplateRef]="!hasCallQueues ? fallback : null"
>
   @if (viewMode === tileViewModes.Large || tileConfig.dashboardTileLayoutConfiguration.width >= 3) {
   <div class="more-actions" moreactions>
      @if (tileData?.data) {
      <div class="average-today">
         <p>Today's Average</p>
         <strong>{{ formatAverageToSeconds(tileData.data.averageWaitTimeToday) }}s</strong>
      </div>
      } @if (tileData?.data) {
      <div class="average-last-30">
         <p>Last 30 minutes</p>
         <strong>{{ formatAverageToSeconds(tileData.data.averageWaitTimeLast30Minutes) }}s</strong>
      </div>
      }
   </div>
   }

   <!-- Custom Tooltips -->
   <ng-template #tooltipTemplateRef let-model="model">
      <div class="ndt-line-chart-tooltip">
         <h2 class="tooltip-title">
            @if (chartType === ChartDisplayType.VerticalLine) {
            {{ model.series }}
            <mat-icon>circle</mat-icon>
            }
            {{ xAxisTickFormatting(model.name) }}
         </h2>
         <p class="tooltip-body">
            Average wait time:
            <strong>{{ formatAverageToSeconds(model.value) | durationToRelativeFormat : 0 }}</strong>
         </p>
      </div>
   </ng-template>

   <!-- Custom Series Tooltips -->
   <ng-template #seriesTooltipTemplateRef let-model="model">
      <div class="ndt-line-chart-tooltip ndt-line-chart-series-tooltip">
         @for (data of model; track data) {
         <div class="tooltip-body">
            <span class="color-block" [style.background-color]="data.color"></span>
            <p class="series-name">{{ data.series }}:</p>
            <strong class="series-value">{{
               formatAverageToSeconds(data.value) | durationToRelativeFormat : 0
            }}</strong>
         </div>
         }
      </div>
   </ng-template>
</qmg-graph-tile>

<ng-template #fallback>
   @if (!hasCallQueues) {
   <div>
      {{ isPreview ? 'Make selections to preview.' : 'Call queues are missing. Please reconfigure.' }}
   </div>
   }
</ng-template>
